var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 48,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    transform: "translate(-24.83 126.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    transform: "translate(38.3 -112.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "cls-2",
    d: "M53.892-91.872H39.752A1.454,1.454,0,0,1,38.3-93.324v-14.141a1.454,1.454,0,0,1,1.452-1.452H50.8a.568.568,0,0,1,.568.568.568.568,0,0,1-.568.568H39.752a.316.316,0,0,0-.315.315v14.141a.316.316,0,0,0,.315.315H53.893a.319.319,0,0,0,.315-.315v-11.049a.568.568,0,0,1,.568-.568.568.568,0,0,1,.568.568v11.048A1.454,1.454,0,0,1,53.892-91.872Z",
    transform: "translate(-38.3 108.916)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    transform: "translate(45.114 -116.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "cls-2",
    d: "M50.862-102.145a.567.567,0,0,1-.4-.166.568.568,0,0,1,0-.8L64.1-116.75a.568.568,0,0,1,.8,0,.568.568,0,0,1,0,.8L51.264-102.311A.567.567,0,0,1,50.862-102.145Z",
    transform: "translate(-50.294 116.916)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    transform: "translate(51.935 -116.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "cls-2",
    d: "M69.684-108.962a.568.568,0,0,1-.568-.568v-6.25h-6.25a.568.568,0,0,1-.568-.568.568.568,0,0,1,.568-.568h6.818a.568.568,0,0,1,.568.568v6.818A.568.568,0,0,1,69.684-108.962Z",
    transform: "translate(-62.298 116.916)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconMobile);
export default __webpack_public_path__ + "static/media/logout-icon-mobile.38e82d86.svg";
export { ForwardRef as ReactComponent };